import { defineComponent as r, openBlock as n, createBlock as l, unref as a, mergeProps as c, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconFactory",
  __name: "IconFactory",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (n(), l(a(i), c(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "m16.695 4.75-.807 8.065c-.113 1.133-1.492 1.625-2.297.82l-3.325-3.324v2.482c0 1.114-1.346 1.671-2.134.884L4.766 10.31v8.939h14.452L18.31 4.75h-1.616m-1.47-.374a1.25 1.25 0 0 1 1.244-1.126h2.077a1.25 1.25 0 0 1 1.248 1.172l.937 15a1.25 1.25 0 0 1-1.247 1.328H4.516a1.25 1.25 0 0 1-1.25-1.25V9.707c0-1.114 1.347-1.671 2.134-.884l3.366 3.366V9.707c0-1.114 1.347-1.671 2.134-.884l3.527 3.528.798-7.975",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
